import React from 'react';

export const PageSectionTitle = props => {
    const { title } = props;
    return <h4 className="logo-font gradient my-0 py-0 d-inline">{title}</h4>;
};
